import React, { FunctionComponent, useEffect, useState } from 'react'
import { reactular } from '@vendhq/reactular'
import classNames from 'classnames'
import { LoaderSpinner, Section } from '@lightspeed/design-system-react'
import {
  useIsCalculatingSale,
  usePosStateManager,
  useRegisterManager,
} from '../../ng-compat/hooks'
import { OpenRegisterPanel } from '../register/OpenRegisterPanel'
import { SaleActions } from './sale-actions/SaleActions'
import { SaleView } from './sale-view'
import { useSaleInitialising } from './useSaleInitialising'
import { useRegisterOpenReminderNeeded } from './useRegisterOpenReminderNeeded'
import { SaleEvents } from './SaleEvents'
import { useShouldDisableActions } from './useShouldDisableActions'
import { useLoadSale } from './useLoadSale'
import { useMoreSaleActions } from './useMoreSaleActions'
import { SaleModals } from './SaleModals'
import { RegisterOpenReminder } from './RegisterOpenReminder'

export const Sale: FunctionComponent = () => {
  const registerManager = useRegisterManager()
  const posStateManager = usePosStateManager()

  const { retrieveParkedSale, saleLoading } = useLoadSale()
  const saleCalculating = useIsCalculatingSale()
  const isInitalising = useSaleInitialising()
  const isRegisterOpenReminderNeeded = useRegisterOpenReminderNeeded()
  const shouldDisableActions = useShouldDisableActions()
  const moreActionsItemHandler = useMoreSaleActions()

  const [isRegisterOpen, setIsRegisterOpen] = useState(
    registerManager.isActiveRegisterOpen()
  )
  const [hasActiveSale, setHasActiveSale] = useState(
    Boolean(posStateManager.getActiveSaleLocalId())
  )

  useEffect(() => {
    const setoOpen = () =>
      setIsRegisterOpen(registerManager.isActiveRegisterOpen())

    registerManager.on('activeRegisterClose', setoOpen)
    registerManager.on('activeRegisterOpen', setoOpen)
    registerManager.on('registerIdChange', setoOpen)

    return () => {
      registerManager.off('activeRegisterClose', setoOpen)
      registerManager.off('activeRegisterOpen', setoOpen)
      registerManager.off('registerIdChange', setoOpen)
    }
  }, [registerManager])

  useEffect(() => {
    const setActive = () =>
      setHasActiveSale(Boolean(posStateManager.getActiveSaleLocalId()))

    posStateManager.on('activeSaleLocalIdChange', setActive)

    return () => {
      posStateManager.off('activeSaleLocalIdChange', setActive)
    }
  }, [posStateManager])

  if (!isRegisterOpen) {
    return (
      <>
        <SaleModals />
        <SaleEvents />
        <Section>
          <OpenRegisterPanel />
        </Section>
      </>
    )
  }

  if (!isInitalising && !hasActiveSale && isRegisterOpenReminderNeeded) {
    return (
      <>
        <SaleModals />
        <SaleEvents />
        <RegisterOpenReminder />
      </>
    )
  }

  if (saleLoading) {
    return (
      <>
        <SaleModals />
        <SaleActions
          shouldDisableActions={shouldDisableActions}
          retrieveParkedSale={retrieveParkedSale}
          moreActionsItemHandler={() => {}}
        />
        <LoaderSpinner className="sale-list-loader" />
        <SaleEvents />
      </>
    )
  }

  return (
    <>
      <div>
        <SaleActions
          shouldDisableActions={shouldDisableActions}
          retrieveParkedSale={retrieveParkedSale}
          moreActionsItemHandler={moreActionsItemHandler}
        />
      </div>
      <form
        id="pro-sl-sale-form"
        name="saleCtrl.saleForm"
        className={classNames('wr-current-sale-panel-content', {
          'pro-sale-ready': !saleCalculating,
        })}
      >
        {isInitalising ? (
          <div className="vd-loader sale-list-loader"></div>
        ) : (
          <div className="wr-current-sale-panel-content">
            {
              // TODO: Replace this with the content of SaleView when ready
            }
            <SaleView />
          </div>
        )}
      </form>
      <SaleEvents />
      <SaleModals />
    </>
  )
}

export const ReactSaleRootComponent = reactular(Sale, [], 'reactWrapper')
